import { getRequest, postRequest } from './fetch';
import { baseUrl } from './env';
// 新闻列表查询
const GetInformationListForWebSite = (data) => getRequest(`${baseUrl}/dev/Information/GetInformationListForWebSite`, data);
// 合伙人招募注册体验
const AddPartnerInfo = (data) => postRequest(`${baseUrl}/dev/Partner/AddPartnerInfo`, data);
// 首页立即体验域名
const serviceUrl = 'https://report.imaginelearning.cn';
// 全国校区地图
const GetCooperationNumberList = (data) => getRequest(`${baseUrl}/dev/CooperationNumber/GetCooperationNumberList`, data);
const GetTotalCooperationNumber = (data) => getRequest(`${baseUrl}/dev/CooperationNumber/GetTotalCooperationNumber`, data);
const GetProvinceCooperationList = (data) => getRequest(`${baseUrl}/dev/CooperationNumber/GetProvinceCooperationList`, data);
// 新闻资讯
// 新闻列表
const getnewsinformationList = (data) => getRequest(`${baseUrl}/dev/Information/GetInformationListForWebSite`, data);
// 新闻详情
const getnewsinformationDetail = (data) => getRequest(`${baseUrl}/dev/Information/GetInformationById`, data);
export {
  GetInformationListForWebSite,
  AddPartnerInfo,
  serviceUrl,
  GetCooperationNumberList,
  GetTotalCooperationNumber,
  GetProvinceCooperationList,
  getnewsinformationList,
  getnewsinformationDetail
};


// WEBPACK FOOTER //
// ./src/config/getData.js